<script>
import debounce from 'lodash/debounce';

// Components
import PrimaryFacets from './primary-facets';
import DistrictFacets from './district-facets';
import ElectionFacets from './election-facets';
import PersonFacets from './person-facets';

export default {
  components: {
    PrimaryFacets,
    DistrictFacets,
    ElectionFacets,
    PersonFacets
  },

  computed: {
    params () { return this.$store.getters['databaseSearch/params'] },
    searching () { return this.$store.state.databaseSearch.searching },
  },

  watch: {
    params: debounce( function(event) {
      this.search();
    }, 250)
  },

  methods: {
    search () {
      const self = this;
      self.$router.replace({ query: self.params });
      if ( Object.keys(self.params).length === 0 && self.params.constructor === Object ) {
        self.$store.commit('databaseSearch/clearResults');
      } else {
        self.$store.dispatch('databaseSearch/getResults');
      }
    },
  }
}

</script>

<template lang="html">
  <form action="/search" method="get" class="DatabaseSearch-form u-form u--form--light" @submit.prevent>
    <primary-facets></primary-facets>
    <district-facets v-if="params.recordType === 'District'"></district-facets>
    <election-facets v-if="params.recordType === 'Election'"></election-facets>
    <person-facets v-if="params.recordType === 'Person'"></person-facets>
  </form>
</template>



// WEBPACK FOOTER //
// search-form.vue?2095b211